import { request } from "@/interface/helper";

const str = "token";

export const token = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/token/list" }),
    add: data => request({ data, method: "post", url: "/token/add" }),
    addSpider: data => request({ data, method: "post", url: "/token/addspider" }),
    detail: data => request({ data, method: "post", url: "/token/detail" }),
    edit: data => request({ data, method: "post", url: "/token/modify" })
  }
};
